export default "__VITE_ASSET__b05e87c7__"